import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING, EDIT } from "const"
import { MarkovState } from "server/models"
import { StateType, deepCopy, hasAccess } from "client/utils"
import {
    PRM_MARKOV_MODEL,
    StoreType,
    MarkovStateList,
    MarkovStateFilters,

    LoadAllMarkovStates,
    DeleteMarkovState,
    SortMarkovStates,

    setMarkovStateList,
    setMarkovStateIds,
    setMarkovStateSort,
    setMarkovStateFilters,
    addModal,
} from "client/store"

import {
    Collapse,
    Container,
    Loader,
    Button,
    Table,
    TableSearchWrapper,
    SortRows,
    DeleteRow,
} from "client/components"

import MarkovStateSearch from "client/pages/search/markovStateSearch"
import EditState from "client/pages/markov/state/edit"
import Columns from "./columns"


const List = () => {
    const model = useSelector((state: StoreType) => state.markovModel.modelView)

    const stateList = useSelector((state: StoreType) => state.markovState.stateList)
    const stateIds = useSelector((state: StoreType) => state.markovState.stateIds)
    const sortColumn = useSelector((state: StoreType) => state.markovState.sortColumn)
    const sortOrder = useSelector((state: StoreType) => state.markovState.sortOrder)
    const filters = useSelector((state: StoreType) => state.markovState.filters)
    const reloadList = useSelector((state: StoreType) => state.markovState.reloadList)

    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)
    const [show, setShow] = useState(false)

    useEffect(() => {
        if (!reloadList) return
        setLoadState(PENDING)
        LoadAllMarkovStates(model && model.id).then((res) => {
            dispatch(setMarkovStateList(res))
            setLoadState(IDLE)
        })
    }, [model, reloadList])

    useEffect(() => {
        const sortedIds = SortMarkovStates(Object.values(stateList), sortColumn, sortOrder, filters)
        dispatch(setMarkovStateIds(sortedIds))
    }, [stateList, sortColumn, sortOrder, filters])

    const onSort: SortRows = (column: keyof MarkovState, order) => {
        dispatch(setMarkovStateSort(column, order))
    }

    const onFilter = (newFilters: MarkovStateFilters) => {
        dispatch(setMarkovStateFilters(newFilters))
    }

    const onDelete: DeleteRow = (state: MarkovState, callback) => {
        DeleteMarkovState(state.id, model.id).then((removedRows) => {
            const success = removedRows === 1
            callback(success, () => {
                const stateListCopy: MarkovStateList = stateList ? deepCopy(stateList) : {}
                delete stateListCopy[state.id]
                dispatch(setMarkovStateList(stateListCopy))
                dispatch(setMarkovStateIds(stateIds.filter((id) => id !== state.id)))
            })
        })
    }

    const columns = Columns()
    const editModelAccess = hasAccess(PRM_MARKOV_MODEL, EDIT)

    return (
        <Collapse
            show={show}
            onCollapse={() => setShow(!show)}
            title={lang.states}
        >
            <Container>
                {
                    loadState === PENDING
                    && <Loader />
                }
                <TableSearchWrapper>
                    <MarkovStateSearch
                        id="stateList"
                        rightOffset={editModelAccess}
                        filters={filters}
                        onFilter={onFilter}
                    />
                    {
                        editModelAccess && (
                            <Button
                                variant="success"
                                onClick={() => dispatch(addModal({
                                    key: "addState",
                                    content: <EditState stateId={0} />,
                                }))}
                            >
                                {lang.add}
                            </Button>
                        )
                    }
                </TableSearchWrapper>
                <Table
                    columns={columns}
                    dataList={stateList}
                    dataIds={stateIds}
                    sortColumn={sortColumn}
                    sortOrder={sortOrder}
                    rowSize="sm"
                    showPagination
                    scrollToTopOnPagination={false}
                    onSort={onSort}
                    onDelete={onDelete}
                />
            </Container>
        </Collapse>
    )
}
export default List
